export enum FetchStrategy {
  Autofetch = 1,
  BackgroundFetch = 2,
}
